import axios from "axios";

const API = axios.create({
  baseURL: "https://admin.zedexsoftware.in/api/SCPL",
  headers: {
    "Content-Type": "application/json",
  },
});

// ✅ Correct POST API
export const trackShipmentPOST = (awbno) => {
  return API.post("/ShipmentTrack", {
    awbno: awbno,
  });
};